/* BWL 2026-07: Dawn's product modal rebuilt as a lightbox — single centered
   image, counter, prev/next, thumbnails, keyboard + swipe, click-to-zoom.
   Navigation respects the per-variant media suites (media-vhidden on the
   gallery list items). */
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.stage = this.querySelector('.product-media-modal__content');
        this.counter = this.querySelector('.bwl-lightbox__counter');
        this.thumbStrip = this.querySelector('.bwl-lightbox__thumbs');
        this.thumbs = Array.from(this.querySelectorAll('.bwl-lightbox__thumb'));
        this.onKey = this.onKey.bind(this);

        this.querySelector('.bwl-lightbox__nav--prev')?.addEventListener('click', () => this.step(-1));
        this.querySelector('.bwl-lightbox__nav--next')?.addEventListener('click', () => this.step(1));
        this.thumbs.forEach((thumb) =>
          thumb.addEventListener('click', () => this.setActiveMedia(thumb.dataset.thumbTarget))
        );

        // empty space around the media closes; the media itself zooms
        this.stage.addEventListener('pointerup', (event) => {
          if (event.target === this.stage) this.hide();
        });
        this.stage.addEventListener('click', (event) => {
          const image = event.target.closest('img[data-media-id]');
          if (!image || !image.classList.contains('active')) return;
          const rect = image.getBoundingClientRect();
          const originX = ((event.clientX - rect.left) / rect.width) * 100;
          const originY = ((event.clientY - rect.top) / rect.height) * 100;
          image.style.transformOrigin = `${originX}% ${originY}%`;
          image.classList.toggle('is-zoomed');
        });

        this.stage.addEventListener('touchstart', (event) => {
          this.touchStartX = event.touches[0].clientX;
        }, { passive: true });
        this.stage.addEventListener('touchend', (event) => {
          if (this.touchStartX == null) return;
          const deltaX = event.changedTouches[0].clientX - this.touchStartX;
          this.touchStartX = null;
          if (Math.abs(deltaX) > 45) this.step(deltaX > 0 ? -1 : 1);
        }, { passive: true });
      }

      visibleItems() {
        // mirror the gallery's per-variant filter (bwl-variant-media.js)
        const hiddenIds = new Set(
          Array.from(document.querySelectorAll('.product__media-list > li.media-vhidden')).map((li) =>
            String(li.dataset.mediaId || '').split('-').pop()
          )
        );
        return Array.from(this.stage.querySelectorAll('[data-media-id]')).filter(
          (el) => !hiddenIds.has(String(el.dataset.mediaId))
        );
      }

      show(opener) {
        super.show(opener);
        this.items = this.visibleItems();
        const visibleIds = new Set(this.items.map((el) => String(el.dataset.mediaId)));
        this.stage.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.toggle('bwl-lightbox-hidden', !visibleIds.has(String(el.dataset.mediaId)));
        });
        this.thumbs.forEach((thumb) => {
          thumb.classList.toggle('bwl-lightbox-hidden', !visibleIds.has(String(thumb.dataset.thumbTarget)));
        });

        let target = opener && opener.getAttribute('data-media-id');
        if (!visibleIds.has(String(target))) target = this.items[0] && this.items[0].dataset.mediaId;
        this.setActiveMedia(target);
        document.addEventListener('keydown', this.onKey);
      }

      hide() {
        document.removeEventListener('keydown', this.onKey);
        this.stage.querySelectorAll('.is-zoomed').forEach((el) => el.classList.remove('is-zoomed'));
        super.hide();
      }

      onKey(event) {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      }

      step(direction) {
        if (!this.items || !this.items.length) return;
        const currentIndex = this.items.findIndex((el) => el.classList.contains('active'));
        const nextIndex = (currentIndex + direction + this.items.length) % this.items.length;
        this.setActiveMedia(this.items[nextIndex].dataset.mediaId);
      }

      setActiveMedia(mediaId) {
        if (!this.items || !this.items.length) return;
        mediaId = String(mediaId);
        let activeMedia = null;
        this.stage.querySelectorAll('[data-media-id]').forEach((el) => {
          const isActive = String(el.dataset.mediaId) === mediaId;
          el.classList.toggle('active', isActive);
          el.classList.remove('is-zoomed');
          if (isActive) activeMedia = el;
        });
        if (!activeMedia) return;

        if (this.counter) {
          this.counter.textContent = `${this.items.indexOf(activeMedia) + 1} / ${this.items.length}`;
        }

        this.thumbs.forEach((thumb) => {
          const isActive = String(thumb.dataset.thumbTarget) === mediaId;
          if (isActive) {
            thumb.setAttribute('aria-current', 'true');
            this.thumbStrip.scrollTo({
              left: thumb.offsetLeft - this.thumbStrip.clientWidth / 2 + thumb.clientWidth / 2,
              behavior: 'smooth',
            });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        window.pauseAllMedia();
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMedia.querySelector('template')) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
